import { Tag } from 'tags/models/tags';

const MAX_TAG_NAME_LENGTH = 50;
const MAX_ASSIGNED_TAGS = 20;

export const validateTagLength = (tag: string, maxLength: number = MAX_TAG_NAME_LENGTH) => {
  return tag.length < maxLength;
};

export const validateNumberOfAssignedTags = (
  assignedTags: Tag[],
  maxNumberOfTags: number = MAX_ASSIGNED_TAGS,
) => {
  return assignedTags.length < maxNumberOfTags;
};
